export const sizesMap = {
  xxxs: { size: '0.5rem' },
  xxs: { size: '0.675rem' },
  xs: { size: '0.75rem' },
  sm: { size: '0.875rem' },
  base: { size: '1rem' },
  lg: { size: '1.125rem' },
  xl: { size: '1.25rem' },
  xxl: { size: '1.5rem' },
  xxxl: { size: '1.875rem' },
  xxxxl: { size: '3.35rem' },
};

export const typographyMarginBottom = (hidden?: boolean) =>
  hidden ? '0' : '0 0 0.4em 0';

export const textLineHeight = 1.5;
export const textLetterSpacing = '0.02em';

export const headingLineHeight = 1.3;
export const headingLetterSpacing = '0.02em';

export const fontFamilyMap = {
  serif: 'literata',
  sans: 'gtEesti',
  mono: 'mono',
};

export const headingTypeMap = {
  1: sizesMap['xxxxl'],
  2: sizesMap['xxxl'],
  3: sizesMap['xxl'],
  4: sizesMap['xl'],
  5: sizesMap['lg'],
  6: sizesMap['base'],
};

export const weightMap = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 500,
  bold: 700,
};
